export default __webpack_public_path__ + "ui/assets/img/blocked-20.svg";